<template>
  <section class="content">
    <div class="row center-block">
      <!--<div class="col-lg-3 col-sm-6 col-xs-12 p-x-10">-->
        <!--<div class="info-box">-->
          <!--<span class="info-box-icon bg-aqua"><i class="ion ion-document-text"></i></span>-->
          <!--<div class="info-box-content">-->
            <!--<span class="info-box-text m-t-5">總訂單</span>-->
            <!--<span class="info-box-number text-35">{{ordersAmount}}</span>-->
          <!--</div>-->
        <!--</div>-->
      <!--</div>-->
      <!--<div class="col-lg-3 col-sm-6 col-xs-12 p-x-10">-->
        <!--<div class="info-box">-->
          <!--<span class="info-box-icon bg-red"><i class="ion ion-ios-people"></i></span>-->

          <!--<div class="info-box-content">-->
            <!--<span class="info-box-text m-t-5">總會員</span>-->
            <!--<span class="info-box-number text-35">{{shoppersAmount}}</span>-->
          <!--</div>-->
        <!--</div>-->
      <!--</div>-->
      <div class="col-md-12">
        <div class="box">
          <div class="box-header">
            <h3 class="box-title">{{memberInfo.nickname}}<span v-if="realName">({{realName}})</span>的訂單列表</h3>
          </div>
          <!-- /.box-header -->
          <div class="box-body">
            <order-table />
            <!-- /.box-body -->
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
// Require needed datatables modules
import { mapGetters } from 'vuex'
import orderTableTemp from '../Order/Temp/OrderTableTemp.vue'
export default {
  name: 'Tables',
  data () {
    return {
      roleType: 99,
      memberInfo: {}
    }
  },
  mounted () {
  },
  methods: {
    getMemberById () {
      var self = this
      if (this.$route.params.user_id) {
        var url = '/shopper/' + this.$route.params.user_id
        this.loginType = 99
        this.getDataH('get', url, null, function (response) {
          if (response.data.status === 200) {
            self.memberInfo = response.data.shopper_info
          }
        })
      }
    },
    getBrandMemberById () {
      var self = this
      if (this.$route.params.user_id) {
        var url = '/shopper/' + this.$route.params.user_id + '/basic'
        this.loginType = 99
        this.getDataH('get', url, null, function (response) {
          if (response.data.status === 200) {
            self.memberInfo = response.data.shopper_info
          }
        })
      }
    }
  },
  components: {
    'order-table': orderTableTemp
  },
  computed: {
    ...mapGetters(['getRoleType']),
    getDataH () {
      return this.$parent.getDataH
    },
    realName () {
      return this.memberInfo.last_name + this.memberInfo.first_name
    }
  },
  created () {
    this.roleType = parseInt(this.getRoleType, 10)
    if (this.roleType === 99) this.getMemberById()
    else if (this.roleType === 30 || this.roleType === 10) this.getBrandMemberById()
  }
}
</script>



// WEBPACK FOOTER //
// MemberOrderTable.vue?2e8752f4